import controller from './emulator.controller';

const template = require('./emulator.html');

export default {
    controller,
    template
};
